import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTenantSelection } from '@/contexts/TenantSelectionContext';
import { TenantSelector } from '@/components/platform-admin/TenantSelector';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Building2 } from 'lucide-react';

interface TenantSelectionInterceptorProps {
  feature: string;
  featureTitle: string;
  featureDescription: string;
}

export function TenantSelectionInterceptor({ 
  feature, 
  featureTitle, 
  featureDescription 
}: TenantSelectionInterceptorProps) {
  const { selectedTenant } = useTenantSelection();
  const navigate = useNavigate();

  useEffect(() => {
    if (selectedTenant) {
      navigate(`/platform-admin/tenant/${selectedTenant.id}/${feature}`, { replace: true });
    }
  }, [selectedTenant, feature, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/50">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <Building2 className="h-12 w-12 text-primary" />
          </div>
          <CardTitle className="text-2xl">{featureTitle}</CardTitle>
          <CardDescription className="text-base">
            {featureDescription}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="text-center">
              <p className="text-sm text-muted-foreground mb-4">
                Select a tenant to manage their {feature.replace('-', ' ')}:
              </p>
            </div>
            <TenantSelector />
            <div className="text-center">
              <p className="text-xs text-muted-foreground">
                You will be redirected to the selected tenant's {feature.replace('-', ' ')} interface.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}